/**
 * Origin for Labra flyout asset URLs that should be rewritten to the current app origin.
 * When the buyer logo (or other asset) points here, we serve it from the same domain
 * to avoid cross-origin issues and use the correct environment.
 */
const ASSETS_FLYOUT_ORIGIN = 'https://assets.flyout.labra.io'

/**
 * Resolves a buyer logo URL so that assets hosted on assets.flyout.labra.io
 * are served from the same origin as the app.
 *
 * Example: if the page is at https://qa.app.labra.io and the URL is
 * https://assets.flyout.labra.io/default/default.svg, returns
 * https://qa.app.labra.io/default/default.svg
 *
 * @param url - The logo URL (e.g. buyerInfo.logoUrl or buyerLogoUrl)
 * @returns The same URL, or the rewritten same-origin URL when from assets.flyout.labra.io
 */
export function resolveBuyerLogoUrl(
  url: string | undefined | null
): string | undefined {
  if (url == null || typeof url !== 'string' || url.trim() === '') {
    return undefined
  }

  try {
    const parsed = new URL(url)
    if (parsed.origin !== ASSETS_FLYOUT_ORIGIN) {
      return url
    }

    const path = parsed.pathname.startsWith('/')
      ? parsed.pathname.slice(1)
      : parsed.pathname

    if (typeof window !== 'undefined' && window.location?.origin) {
      return `${window.location.origin}/${path}`
    }

    return `/${path}`
  } catch {
    return url
  }
}
